import axiosServices from "../utils/axios";

export const addDockrestrictionReport= async (data: { [key: string]: any }) => {
  const response = await axiosServices.post(`/reports/dockrestrictionreport`, data);
  return (response.data);
};

export const getDockrestrictionReport = async (params: { notification_intro: String; portCalls: string; mode:any}) => {
  const { notification_intro, portCalls, mode } = params;
  const url=`/reports/dockrestrictionreport?mode=${mode}&notification_intro=${notification_intro}&portCalls=${portCalls}`;
  const response = await axiosServices.get(`${url}`);
  return response
};